import axios from "@/axios/axios";
import { napStatus } from "@/data/constances";

export default {
  namespaced: true,
  state: {
    napMatchingHistoryList: [],
    selectedNapMatchingHistory: {},
    statistic: {
      all: 0,
      pending: 0,
      approve: 0,
      reject: 0,
      deleted: 0,
    },
  },
  actions: {
    loadAllNapMatchingHistory({ commit }) {
      return axios
        .get("/api/matching/nap/history/all")
        .then((response) => {
          if (response.status == 200) {
            commit("setNapMatchingHistoryList", response.data);
            return Promise.resolve(response);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    loadNapMatchingHistoryByStatus({ commit, dispatch }, params) {
      if (!params.status) {
        dispatch("loadAllNapMatchingHistory");
        return;
      }
      return axios
        .get("/api/matching/nap/history/get-by-status", { params })
        .then((response) => {
          if (response.status == 200) {
            commit("setNapMatchingHistoryList", response.data);
            return Promise.resolve(response);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    getNapMatchingHistoryDetail({ commit }, idx) {
      return axios
        .get("/api/matching/nap/history/get", {
          params: { idx },
        })
        .then((response) => {
          if (response.status == 200) {
            commit("setSelectedNapMatchingHistory", response.data);
            return Promise.resolve(response);
          } else {
            commit("setSelectedNapMatchingHistory", {});
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    getNapMatchingStatistic({ commit }) {
      Promise.all([
        axios.get("/api/matching/nap/history/count-status", {
          params: { status: napStatus.PENDING },
        }),
        axios.get("/api/matching/nap/history/count-status", {
          params: { status: napStatus.APPROVED },
        }),
        axios.get("/api/matching/nap/history/count-status", {
          params: { status: napStatus.REJECT },
        }),
        axios.get("/api/matching/nap/history/count-status", {
          params: { status: napStatus.DELETED },
        }),
      ]).then((values) => {
        let data = {
          all: 0,
          pending: 0,
          approve: 0,
          reject: 0,
          deleted: 0,
        };

        if (values[0]?.status == 200) data.pending = values[0].data;
        if (values[1]?.status == 200) data.approve = values[1].data;
        if (values[2]?.status == 200) data.reject = values[2].data;
        if (values[3]?.status == 200) data.deleted = values[3].data;
        data.all = data.pending + data.approve + data.reject + data.deleted;

        commit("setNapMatchingStatistic", data);
      });
    },
  },
  mutations: {
    setNapMatchingHistoryList(state, payload) {
      state.napMatchingHistoryList = payload;
    },
    setSelectedNapMatchingHistory(state, payload) {
      state.selectedNapMatchingHistory = payload;
    },
    setNapMatchingStatistic(state, payload) {
      state.statistic = payload;
    },
  },
};
